export class FsOnAfterInitEvent {}
export class FsOnExternalValueChangeEvent {}
export class FsOnBeforeSaveEvent {
  constructor(data) {
    this.data = data;
  }
}
export class FsOnUpdateFormControlReadonlyStateEvent {
  constructor(formGroup) {
    this.formGroup = formGroup;
  }
}
// TODO: specific classes for ModelFormService / CrudItemFormService
// emits either responseData from server or an error wrapped in an AppMessage.
// handling of errors is optional as AppMessages will auto-display if not handled manually.
export class FsOnAfterSaveEvent {
  get responseData() {
    return this.payload.responseData;
  }
  get item() {
    return this.payload.item;
  }
  get error() {
    return this.payload.error;
  }
  constructor(payload) {
    this.payload = payload;
  }
}